import { ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL } from '@siptel-web/common';
import React from 'react';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '..';

function CambiarEstadoSistemaOperativoInvitadoModal(props) {
  const { open, close, afterConfirm } = props;
  const { fetch: sendRequest, loading } = useFetch();

  const idMaquinaVirtual = props?.data?.id;

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const cambiarEstado = React.useCallback(async () => {
    await sendRequest(`/maquinas-virtuales/${idMaquinaVirtual}/so-invitado`, {
      method: 'POST',
      data: { accion: props?.data?.accion },
    });

    if (typeof afterConfirm === 'function') {
      afterConfirm();
    }
    close();
  }, [sendRequest, idMaquinaVirtual, afterConfirm, props?.data?.accion, close]);

  let accion = 'Apagar';

  switch (props.data.accion) {
    case ACCIONES_SISTEMA_OPERATIVO_INVITADO_MAQUINA_VIRTUAL.REINICIAR:
      accion = 'Reiniciar';
      break;
    default:
      accion = 'Apagar';
  }

  return (
    <Modal
      title={`${accion} Sistema Operativo Invitado: ${idMaquinaVirtual}`}
      content="¿Está seguro de querer efectuar éste cambio?"
      open={open}
      close={onCloseModal}
      onConfirm={cambiarEstado}
      isConfirming={loading}
      disabled={loading}
      confirmButtonText="Confirmar"
      cancelButtonText="Cancelar"
    />
  );
}

export default CambiarEstadoSistemaOperativoInvitadoModal;
